const url = {
  local: `http://localhost:3010/v1`,
  develop: "https://dev-apigateway.artprovincia.com.ar",
  test: "https://test-apigateway.artprovincia.com.ar",
  beta: "https://beta-apigateway.artprovincia.com.ar",
  master: "https://apigateway.artprovincia.com.ar",
  prod: "https://apigateway.artprovincia.com.ar",
};

/**
 * @description Returns the url of the environment to test
 * @param { keyof url } branch develop, test, beta, main, master
 * @returns { string } url
 */
export const obtainEnvironment = (branch) => {
  let resultUrl = url[branch] || url["develop"];
  if (branch !== "local") {
    resultUrl += "/" + import.meta.env.VITE_PROJECT_PATH_BACK + "/v1";
  }
  
  console.info(`Branch: ${branch} -> Environment URL: ${resultUrl}`);
  return resultUrl;
};

/**
 * Ajusta automáticamente los prefijos de URL según el entorno.
 *
 * Lógica de ambientes:
 * - Ambientes bajos (develop/test): Se ajustan automáticamente entre desa y test
 * - Ambientes altos (beta/master): Se ajustan automáticamente entre beta y prod
 *
 * @param { keyof url } branch develop, test, beta, main, master
 * @param {string} baseUrl URL base en la cual se ajusta el prefijo.
 * @returns {string} URL con el prefijo adecuado según el entorno.
 */
export function mapUrlByBranch(branch, baseUrl) {
  switch (branch) {
    case 'master':
    case 'prod': // 'prod' should be analogous to 'master'
      // Producción: si tiene beta-producto..., quitarlo para que sea producto...
      return baseUrl.replace(/(https?:\/\/)beta-/i, '$1');
    
    case 'test':
      // Test: si tiene desa-producto..., cambiarlo a test-producto...
      return baseUrl.replace(/(https?:\/\/)desa-/i, '$1test-');
    
    case 'develop':
      // Develop: si tiene test-producto..., cambiarlo a dev-producto...
      return baseUrl.replace(/(https?:\/\/)test-/i, '$1dev-');
    
    case 'beta':
      // Beta: si tiene producto... (sin prefijo), agregar beta-producto...
      // Solo agregar si no tiene ya un prefijo de entorno
      if (!/https?:\/\/(beta-|test-|desa-|dev-)/i.test(baseUrl)) {
        return baseUrl.replace(/(https?:\/\/)/i, '$1beta-');
      }
      return baseUrl;
    
    case 'local':
    default:
      return baseUrl;
  }
}
